/**
 * =========================================================
 * videoCallStore — Gjendja globale e thirrjes video
 * =========================================================
 * Çfarë bën: Ruan meeting_link aktiv që VideoCallFrame
 *            të mund të persist-ojë si PiP (Picture-in-Picture)
 *            kur mjeku navigon jashtë faqes /app/messages.
 * =========================================================
 */

import { create } from "zustand";

interface VideoCallStore {
  /** URL-ja aktive Jitsi — null nëse nuk ka thirrje. */
  meetingLink: string | null;
  /** Fillo PiP kur user klikoni "Bashkohu". */
  startPiP: (link: string) => void;
  /** Mbyll thirrjen — pastro gjendjen. */
  endPiP: () => void;
}

export const useVideoCallStore = create<VideoCallStore>((set) => ({
  meetingLink: null,
  startPiP: (link) => set({ meetingLink: link }),
  endPiP:   ()     => set({ meetingLink: null  }),
}));
